import { clsx } from "clsx";
import { type ReactNode } from "react";
import { type MouseProps } from "../types.ts";
import * as styles from "./Award.module.less";
import { toastProps, useToast } from "./context.tsx";

export function Award({
  icon,
  tone = "accent",
  children,
  ...props
}: {
  readonly icon: ReactNode;
  /**
   * Colour of the pulsing halo behind the icon. Defaults to the theme accent;
   * `gold` is for icons that are gold themselves, which an accent-coloured
   * corona would fight, and `success` is for green ones.
   */
  readonly tone?: "accent" | "gold" | "success";
  readonly children: ReactNode;
} & MouseProps): ReactNode {
  const toast = useToast();
  return (
    <div
      {...props}
      className={clsx(
        styles.award,
        tone === "gold" && styles.gold,
        tone === "success" && styles.success,
      )}
      {...toastProps(toast)}
    >
      <div className={styles.icon}>{icon}</div>
      <div className={styles.message}>{children}</div>
    </div>
  );
}
